import './Navbar.css';
import NavBarIco from "./NavBarIco";
import {useTypedSelector} from "../../../hooks/useTypedSelector";

function NavbarBottom() {
    const {tutorial} = useTypedSelector(state => state.auth);

    const grayMode =
        tutorial.step === "Welcome10"
        || tutorial.step === "ClickBossOnMap20"
        || tutorial.step === "Final150"
        || (tutorial.isActive && tutorial.step === "ArenaStart200");


    return ( <div
        className={`navbarBottom ${grayMode ? "navbarBottom--gray" : ""}`}
        aria-disabled={grayMode || undefined}
    >

        <NavBarIco key='navBar_ico_1' route={'gallery'} className={'m_n_gallery'} />

        <NavBarIco key='navBar_ico_2' route={'deck'} className={'m_n_deck'} />

        <NavBarIco key='navBar_ico_3' route={'workshop'} className={'m_n_workshop'} />

        <NavBarIco key='navBar_ico_4' route={'offers'} className={'m_n_shop'} />

        <NavBarIco key='navBar_ico_5' route={'gem_shop'} className={'m_n_gemshop'} />

        <NavBarIco key='navBar_ico_6' route={'settings'} className={'m_n_setting'} />



    </div>)
}

export default NavbarBottom;
